
import React from 'react';
import classNames from 'classnames';
import { Image, Button, Upload } from 'antd';
import { Close, PictureAdd } from '@nackle/origami-icons';
const { Dragger } = Upload;

import './url-editor.less';

export default class UrlEditor extends React.Component {
    state = {
        imageLoaded: false,
        imageWidth: '',
        imageHeight: '',
        fileName: ''
    };

    render() {
        const {
            value,
            className,
            readOnly,
            disabled
        } = this.props;

        const {
            imageLoaded,
            imageWidth,
            imageHeight,
            fileName
        } = this.state;

        return (
            <span className={ classNames( 'url-editor', className ) }>
                {
                    value || this.state.value ? (
                        <div className="image-container">
                            <img
                                style={ { position: 'absolute', width: 0, height: 0 } }
                                src={ value || this.state.value }
                                onLoad={ this.handleImageLoaded }
                            />
                            <Image
                                src={ value || this.state.value }
                                readOnly={ readOnly }
                                disabled={ disabled }
                            />
                            {
                                imageLoaded && (
                                    <span className="image-dimensions">
                                        { imageWidth } x { imageHeight }
                                    </span>
                                )
                            }
                            {
                                imageLoaded && fileName && (
                                    <span className="image-filename">
                                        { fileName }
                                    </span>
                                )
                            }
                            {
                                imageLoaded && !disabled && !readOnly && (
                                    <a
                                        className="delete"
                                        onClick={ ( e ) => {
                                            e.preventDefault();
                                            this.handleImageDeleted();
                                        } }
                                    >
                                        <Close />
                                    </a>
                                )
                            }
                        </div>
                    ) : (
                        <Dragger
                            customRequest={ this.uploadFile }
                            onChange={ this.handleChange }
                            showUploadList={ false }
                            disabled={ disabled }
                            readOnly={ readOnly }
                        >
                            <p className="nkl-upload-text">
                                <PictureAdd className="data-loader-hatch-upload-icon" />
                            </p>
                            <p className="ant-upload-text">Drag and Drop an <strong>Image</strong> file here</p>
                            <p className="nkl-upload-text">or</p>
                            <Button disabled={ disabled } type="primary">Select an Image</Button>
                        </Dragger>
                    )
                }
            </span>
        );
    }

    handleChange = ( info ) => {
        const { onChange } = this.props;
        const { status } = info.file;

        if ( status === 'done' ) {
            if ( typeof onChange === 'function' ) {
                onChange( info.file.response.value );
            }
        }
    };
    handleImageDeleted = () => {
        const { onChange } = this.props;

        this.setState( { fileName: '' } );

        if ( typeof onChange === 'function' ) {
            onChange( null );
        }
    };

    handleImageLoaded = ( e ) => {
        this.setState( {
            imageLoaded: true,
            imageWidth: e.target.naturalWidth,
            imageHeight: e.target.naturalHeight
        } );
    };

    uploadFile = async ( { file, onError, onSuccess } ) => {
        if ( file.type.indexOf( 'image/' ) !== 0 ) {
            return onError( 'Not an Image' );
        }

        const reader = new FileReader();

        reader.addEventListener( 'loadend', ( { target } ) => {
            const { result: value } = target;
            onSuccess( { value } );
        }, false );

        reader.readAsDataURL( file );

        this.setState( { fileName: file.name } );
    };

}
